var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDotsSix = function SvgDotsSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 7.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.375 7.125a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8.625 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.375 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8.625 19.875a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.375 19.875a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgDotsSix;